import React from "react";
import Loader from "../Common/Loader/Loader";
import cx from "classnames"
import { Container } from "react-bootstrap";
import { formValueSelector } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";

import ClearAll from "./ClearAll/ClearAll";
import ClearCart from "./ClearCart/ClearCart";
import CommonModal from "../Modal/CommonModal";

import messages from "../../locale/messages";

import { addOrderAction } from "../../actions/order/addOrderAction";
import { openHeaderModal, closeHeaderModal } from "../../actions/siteadmin/modalActions";

import useQueryResponse from "../../lib/hooks/useQueryResponse";
import getOrder from "./getOrder.graphql";
import bt from '../commonStyle.css';
import s from "./ReviewYourRequestBanner.css"


const ReviewYourRequestBanner = (props) => {
    const {
        resetForm,
        currentCategoryId,
        requestCurrency,
        intl: { formatMessage },
        closeHeaderModal,
        openHeaderModal,
        addOrderAction,
        ordersData,
        loading,
        clearSubCategory,
        clearCart
    } = props

    const { data, loading: getOrderLoading } = useQueryResponse({
        query: getOrder,
        variables: {
            promoId: null
        },
        ssr: false,
        fetchPolicy: 'network-only'
    })
    const closeClearSubCategoryModal = () => {
        closeHeaderModal('clearSubCategory')
    }

    const closeClearCartModal = () => {
        closeHeaderModal('clearCart')
    }

    const handleClick = () => {
        const orderId = data?.getOrder?.result?.id, selectedCategoryId = data?.getOrder?.result?.categoryDetails?.id
        if (orderId && (currentCategoryId !== selectedCategoryId)) {
            openHeaderModal('clearCart')
        }

        else {
            addOrderAction(ordersData)
        }
    }
    const orderId = data?.getOrder?.result?.id
    return (
        <>
            <CommonModal
                title={clearSubCategory ? formatMessage(messages.clearAllTitle) : formatMessage(messages.clearCart)}
                onHide={clearSubCategory ? closeClearSubCategoryModal : closeClearCartModal}
                modalStatus={clearSubCategory ? clearSubCategory : clearCart} >
                {clearSubCategory ? <ClearAll resetForm={resetForm} /> : <ClearCart resetForm={resetForm} orderId={orderId} />}
            </CommonModal >
            <div className={s.reviewYourRequestContainer}>
                <Container>
                    <div className={s.reviewYourRequestWrapper}>
                        <div onClick={() => openHeaderModal('clearSubCategory')} className={bt.viewAllLink}><FormattedMessage {...messages.clearAll} /> </div>
                        <Loader
                            type={"button"}
                            buttonType={'button'}
                            label={formatMessage(messages.reviewYourRequest)}
                            show={loading}
                            handleClick={handleClick}
                            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        >
                        </Loader>
                    </div>
                </Container>
            </div>
        </>
    )
}
const selector = formValueSelector('BookingForm')
const mapState = (state) => ({
    ordersData: selector(state, 'orderData'),
    loading: state.loader?.orderLoading,
    clearSubCategory: state.adminModalStatus.clearSubCategory,
    clearCart: state.adminModalStatus.clearCart,
})
const mapDispatch = {
    addOrderAction,
    openHeaderModal,
    closeHeaderModal
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(ReviewYourRequestBanner)))